<template>
  <!--container-->
  <div class="Background">
    <div class="link_location">
      <h2 class="Title">
        {{ $store.getters.t('설정관리') }} <v-icon small class="mdi mdi-chevron-right" />
        {{ $store.getters.t('일반설정') }} <v-icon small class="mdi mdi-chevron-right" />
        <!-- <a href="/upload/option">업로드 옵션</a> -->
        <span style="color: rgb(29, 120, 211); font-weight: bold;">{{ $store.getters.t('업로드 옵션') }}</span>
      </h2>
    </div>
    <!--table card-->
    <v-card elevation="0">



      <!--table-->

      <v-col class="ml-5">
        <v-radio-group v-model="uploadOption" inline row>
          <v-radio color="black" class="mt-5 pr-5 mr-5" v-for="radio in uOptions" :key="radio.value"
            :label="radio.label" :value="radio.value"></v-radio>
        </v-radio-group>
      </v-col>
    </v-card>

    <v-card :disabled="aes == 0" class="mb-3" elevation="0">
      <v-col class="ml-5">
          <v-radio-group v-model="aesOptionVal" inline row>
            <v-radio color="black" class="mt-5 pr-5 mr-5" v-for="radio in aesOptions" :key="radio.value"
              :label="radio.label" :value="radio.value"></v-radio>
              <v-col class="mt-4" v-show="aes == 0">
                <v-icon class="mdi mdi-information-outline" color="#007bff"/>
                <span  style="font-size: 14px; color: #007bff;" > {{ $store.getters.t('무료플랜에서는 이용할 수 없습니다.') }}</span>
              </v-col>
          </v-radio-group>
      </v-col>
    </v-card>
  
    <v-row justify="end">
      <v-btn :disabled="dialog" :loading="dialog" dark elevation="0" @click="changeRadioSelected">
        {{ $store.getters.t('저장') }}
      </v-btn>
    </v-row>

    <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />

    <!--end-->
  </div>
</template>

<script>
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";
import { mapGetters, mapActions } from 'vuex';


export default {
  computed: {
    ...mapGetters('user', ['upload', 'aesVal']),
    uploadOption: {
      get() {
        return this.upload;
      },
      set(value) {
        this.setUploadOption(value);
      }
    },
    aesOptionVal: {
      get() {
        return this.aesVal;
      },
      set(value) {
        this.setAesOption(value);
      }
    },
    allowList(){
      return this.$store.state.naviList.allowList;
    },
    aes(){
      if(this.allowList){
        return this.allowList.aes;
      } else {  
        return 0; 
      }
    },
    uOptions(){
      return [
          { label: this.$store.getters.t('업로드 퍼블리싱'), value: 2 },
          { label: this.$store.getters.t('업로드 + 인코딩/퍼블리싱 진행'), value: 1 },
      ];
    },
    aesOptions(){
      return [
          { label: this.$store.getters.t('업로드 보안 적용'), value: 1 },
          { label: this.$store.getters.t('업로드 보안 적용 안함'), value: 0 },
      ];
    }
  },
  components: {
    AppSnackbar
  },
  data() {
    return {
      dialog: false,
      // uOptions: [
      //   { label: this.$store.getters.t('업로드 퍼블리싱'), value: 2 },
      //   { label: this.$store.getters.t('업로드 + 인코딩/퍼블리싱 진행'), value: 1 },
      // ],
      // aesOptions: [
      //   { label: this.$store.getters.t('업로드 보안 적용'), value: 1 },
      //   { label: this.$store.getters.t('업로드 보안 적용 안함'), value: 0 },
      // ],
      snackbar: false,
      snackbarText: '',
      snackbarError: false,
      snackbarErrorText: '',
    }
  },
  methods: {
    ...mapActions('user', ['changeUploadOption']),
    async changeRadioSelected() {
      const data = {
        upload_option: this.uploadOption,
        aes_option: this.aesOptionVal
      };

      const response = await this.changeUploadOption(data);

      if (response.success) {
        this.snackbarText = this.$store.getters.t('변경 성공');
        this.snackbarError = false;
        this.snackbar = true;
      } else {
        this.snackbarText = 'Error';
        this.snackbarError = true;
        this.snackbar = true;
      }

      setTimeout(() => {
        this.snackbar = false;
        this.snackbarError = false;
      
        // this.$router.go();
      }, 5000);
    },
    setUploadOption(value) {
      this.$store.commit('user/setUpload', value);
    },
    setAesOption(value){
      this.$store.commit('user/setAes', value);
    }
  }
}
</script>

<style lang="scss" scoped>
/* .drop-area {
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
  cursor: pointer;
} */

.drop-area p {
  margin: 0;
}


.hovered-card {
  background-color: #f0f0f0;
  /* 호버 상태에서의 배경 색상 설정 */
}


.centered-text {
  line-height: 100px;
  font-size: 20px;
  color: #d7d7d7
}

.dotted-outline-card {
  border: 2px dashed #e3e3e3;
  /* 점선 아웃라인 스타일의 테두리와 색상 설정 */
  transition: background-color 0.3s;
}

.custom-data-table>>>.v-data-table__wrapper table tbody tr td {
  font-size: 13px;
}
</style>